<span class="closeModal pull-right" (click)="cancelar()"><i class="fa fa-times"></i></span>
<h1 mat-dialog-title>Ficha Médica</h1>
<mat-dialog-content class="mat-card-content">
    <div #mydiv></div>
    <section>
        <mat-error *ngIf="fichaInvalida" class="fichaInvalida">{{MensajeError}}</mat-error>
        <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

        <div class="row">
            <div class="col-md-6">
                <label class="col-form-label font-bold">Legajo</label>
                <div>
                    <comboTools [list]=personalList
                                [formParent]="registerForm"
                                selected='personal'
                                filter="displayName"
                                (SelectedChange)="onChangePersonal($event)"
                                ph='Empleado'
                    ></comboTools>
                </div>
                <div *ngIf="registerFormControl.personal.invalid && (registerFormControl.personal?.dirty || registerFormControl.personal?.touched || submitted)" class="text-danger">
                    El Empleado es Requerido
                </div>
            </div>
            <div class="col-md-6">
                <label class="col-form-label font-bold">Rubro</label>
                <div>
                    <comboTools [list]=rubrosList
                                selected='rubro'
                                [formParent]="registerForm"
                                ph='Rubro'
                                (SelectedChange)="onChangeRubro($event.value)"
                                filter="descripcion">
                    </comboTools>
                    <div *ngIf="registerFormControl.rubro.invalid && (registerFormControl.rubro?.dirty || registerFormControl.rubro?.touched || submitted)" class="text-danger">
                        El Rubro es Requerido
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <label class="col-form-label font-bold" for="desde">Desde</label>
                <div class="">
                    <p-calendar [appendTo]="mydiv" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" (ngModelChange)="onChangeFechas()" ngDefaultControl></p-calendar>
                    <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                        La Fecha Desde es requerida
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label class="col-form-label font-bold" for="hasta">Hasta</label>
                <div class="">
                    <p-calendar [appendTo]="mydiv" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" (ngModelChange)="onChangeFechas()" ngDefaultControl></p-calendar>
                    <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)"  class="text-danger">
                        La Fecha Hasta es Requerida
                    </div>
                    <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)">
                        La Fecha no puede ser menor que la Fecha Desde
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="porHoras">
            <div class="col-md-6">
              <label class="col-form-label font-bold" for="horaDesde">Hora Desde</label>
              <input type="time" formControlName="horaDesde" name ="selectedhoraDesde" class="form-control" (ngModelChange)="onChangeHoras()" [ngClass]="{ 'is-invalid': registerFormControl.horaDesde.errors && (registerFormControl.horaDesde?.dirty || registerFormControl.horaDesde?.touched || submitted)}"/>
              <div *ngIf="registerFormControl.horaDesde.errors?.required && (registerFormControl.horaDesde?.dirty || registerFormControl.horaDesde?.touched || submitted)" class="text-danger">
                La Hora Desde es requerida
              </div>
            </div>
            <div class="col-md-6">
              <label class="col-form-label font-bold" for="horaHasta">Hora Hasta</label>
              <input type="time" formControlName="horaHasta" name ="selectedhoraHasta" class="form-control" (ngModelChange)="onChangeHoras()" [ngClass]="{ 'is-invalid': registerFormControl.horaHasta.errors && (registerFormControl.horaHasta?.dirty || registerFormControl.horaHasta?.touched || submitted)}"/>
              <div *ngIf="registerFormControl.horaHasta.errors?.required && (registerFormControl.horaHasta?.dirty || registerFormControl.horaHasta?.touched || submitted)" class="text-danger">
                La Hora Hasta es requerida
              </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <label class=" col-form-label font-bold">{{labelCantidad}}</label>
                <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control" disabled [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
                <mat-error  class="text-danger"*ngIf="registerFormControl.cantidad.errors?.required && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)">
                    La Cantidad es Requerida
                </mat-error>
            </div>
            <div class="col-md-6">
                <label class=" col-form-label font-bold">Certificado</label>
                <div class="row">
                    <div class="col-md-4">
                        <p-checkbox formControlName="certificado" binary="true" (onChange)="cambioCertificado($event)"></p-checkbox>
                    </div>
                    <div class="col-md-8" *ngIf="registerFormControl.certificado.value===true && EsEdicion">
                        <!-- <img class= "rounded-circle circle-border m-b-md imagenPersona"
                                alt="image" title="Cambiar Imagen" style="cursor: pointer;" 
                                [src]="selectedImage" (click)="imageInput.click()"
                                [ngClass]="{'img-disabled' : !showDetails}"> -->
    
                        <button (click)="imageInput.click()">
                            Seleccionar Adjunto
                            <input type="file" style="display: none;" (change)="onFileSelected($event)" accept="image/png, image/jpeg" #imageInput>
                        </button>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="form-group">
            <label class=" col-form-label font-bold">Diagnóstico</label>
            <textarea rows="3" formControlName="diagnostico" maxlength="500" name ="selectedDiagnostico" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.diagnostico.errors && (registerFormControl.diagnostico?.dirty || registerFormControl.diagnostico?.touched || submitted)}"></textarea>
            <!-- <input formControlName="diagnostico" maxlength="500" name ="selectedDiagnostico" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.diagnostico.errors && (registerFormControl.diagnostico?.dirty || registerFormControl.diagnostico?.touched || submitted)}"/> -->
            <mat-error  class="text-danger"*ngIf="registerFormControl.diagnostico.errors?.required && (registerFormControl.diagnostico?.dirty || registerFormControl.diagnostico?.touched || submitted)">
                El Diagnóstico es Requerido
            </mat-error>
        </div>

        <div class="form-group">
            <img [src]="selectedImage" *ngIf="selectedImage && registerFormControl.certificado.value===true" alt="Selected Image">
        </div>
        
        
        <div class="buttons">
            <button mat-button type="button" (click)="cancelar()" class="button">Cerrar</button>

            <button *ngIf="permisoEdicion" mat-button type="submit" class="btn btn-primary">Guardar</button>
        </div>
        </form>
    </section>
</mat-dialog-content>
